import { matrix } from './fomoHeroQr.json'

/** Mount the approved liquid hero; the returned disposer owns all animation resources. */
export function createFomoLiquidHero(root) {
  let disposed = false

  const $ = (s) => root.querySelector(s)
  const canvas = $('.fq-canvas')
  const qr = matrix
  const reduced = matchMedia('(prefers-reduced-motion: reduce)')
  const style = { speed: 0.82, life: 1, scene: 'auto', preview: 0 }
  let playing = !reduced.matches,
    visible = true,
    time = 0,
    last = 0,
    raf = 0,
    previousDraw = 0,
    mouse = 0,
    mouseTarget = 0
  const fallback = $('[data-qr-fallback]'),
    fc = fallback.getContext('2d')
  const pitch = fallback.width / (qr.length + 8)
  fc.clearRect(0, 0, fallback.width, fallback.height)
  fc.fillStyle = '#cdc7e2'
  for (let y = 0; y < qr.length; y++)
    for (let x = 0; x < qr.length; x++)
      if (qr[y][x])
        fc.fillRect((x + 4) * pitch, (y + 4) * pitch, Math.ceil(pitch), Math.ceil(pitch))
  const pixels = $('.fq-pixels'),
    pc = pixels.getContext('2d'),
    points = []
  for (let y = 0; y < qr.length; y++)
    for (let x = 0; x < qr.length; x++)
      if (qr[y][x]) {
        const dx = x + 0.5 - qr.length / 2,
          dy = qr.length / 2 - y - 0.5
        points.push({
          x,
          y,
          seed: ((x * 73 + y * 151 + 31) % 257) / 257,
          polar: (Math.atan2(dy, dx) + Math.PI * 2) % (Math.PI * 2),
          radius: Math.min(1, Math.hypot(dx, dy) / (qr.length * 0.65)),
        })
      }
  points.sort((a, b) => a.polar - b.polar || a.radius - b.radius)
  points.forEach((p, i) => {
    p.angle = (i * Math.PI * 2) / points.length
    p.lane = (p.radius - 0.5) * 0.16
  })
  const smooth = (a, b, x) => {
    const t = Math.max(0, Math.min(1, (x - a) / (b - a)))
    return t * t * (3 - 2 * t)
  }
  const waterEase = (a, b, x) => {
    const t = Math.max(0, Math.min(1, (x - a) / (b - a)))
    return t * t * t * (t * (t * 6 - 15) + 10)
  }
  const sculptureScale = () => (root.clientWidth >= 900 ? 1.16 : 1)
  function storyState() {
    const c =
      { qr: 0.2, ribbon: 1.8, ticket: 3.9, stage: 7.8, signal: 11.7 }[style.scene] ?? time % 17.5
    const ticket = waterEase(2.1, 3.45, c) * (1 - waterEase(4.45, 5.8, c)),
      stage = waterEase(5.95, 7.3, c) * (1 - waterEase(8.3, 9.65, c)),
      signal = waterEase(9.8, 11.15, c) * (1 - waterEase(12.2, 13.55, c)),
      code = 1 - waterEase(0.45, 1.7, c) + waterEase(15, 16.5, c)
    return {
      cycle: c,
      ticket,
      stage,
      signal,
      code,
      form:
        code > 0.98
          ? 'qr'
          : ticket > 0.98
          ? 'ticket'
          : stage > 0.98
          ? 'stage'
          : signal > 0.98
          ? 'signal'
          : code > 0.02 || ticket > 0.02 || stage > 0.02 || signal > 0.02
          ? 'morph'
          : 'ribbon',
    }
  }
  const turn = (x, y, a) => [x * Math.cos(a) - y * Math.sin(a), x * Math.sin(a) + y * Math.cos(a)]
  function ribbonPoint(point) {
    const a = point.angle,
      twist = a * 1.5 + 0.32 * Math.sin(time * 0.55) + 0.18 * Math.sin(a * 2 - time * 0.7)
    let [x, y, z] = ribbonCenter(a)
    x += point.lane * Math.cos(twist) * Math.cos(a)
    y += point.lane * Math.cos(twist) * Math.sin(a)
    z += point.lane * Math.sin(twist)
    ;[x, y, z] = applyPose([x, y, z], metalPose(storyState(), 0))
    return { x, y, z }
  }
  function drawCodeFlow(w, h, state, staying) {
    const scale = h / 2.72,
      cell = (1.95 * scale) / qr.length,
      ratio = w / Math.max(1, anchor.clientWidth),
      fade = smooth(0.08, 0.7, state.code) * staying
    const metalStops = [
      [0, [170, 162, 188]],
      [0.28, [213, 213, 224]],
      [0.43, [245, 246, 251]],
      [0.59, [181, 175, 202]],
      [0.78, [222, 222, 233]],
      [1, [184, 175, 204]],
    ]
    const codeMetal = (x, y) => {
      const t = Math.max(
        0,
        Math.min(1, 0.5 + (x + y) / (scale * 3.9) + 0.025 * Math.sin(time * 0.8))
      )
      let i = 1
      while (i < metalStops.length - 1 && t > metalStops[i][0]) i++
      const [a, c] = metalStops[i - 1],
        [b, d] = metalStops[i],
        k = (t - a) / (b - a)
      return `rgb(${c.map((v, j) => Math.round(v + (d[j] - v) * k)).join(',')})`
    }
    pc.globalAlpha = fade
    for (const point of points) {
      const q = ribbonPoint(point),
        delay = 0.045 + 0.11 * point.radius,
        k = smooth(delay, 0.86 + 0.1 * point.radius, state.code),
        u = 1 - k,
        envelope = Math.pow(Math.sin(k * Math.PI), 1.35)
      const ax = q.x * scale * sculptureScale(),
        ay = -q.y * scale * sculptureScale(),
        bx = (point.x + 0.5 - qr.length / 2) * cell,
        by = (point.y + 0.5 - qr.length / 2) * cell
      const tangentX = -Math.sin(point.angle),
        tangentY = -Math.cos(point.angle),
        flow = scale * (0.15 + 0.025 * Math.sin(time * 0.55 + point.angle * 2))
      const c1x = ax + tangentX * flow,
        c1y = ay + tangentY * flow,
        c2x = bx - tangentX * flow * 0.5,
        c2y = by - tangentY * flow * 0.5
      const x = w / 2 + u * u * u * ax + 3 * u * u * k * c1x + 3 * u * k * k * c2x + k * k * k * bx,
        y = h / 2 + u * u * u * ay + 3 * u * u * k * c1y + 3 * u * k * k * c2y + k * k * k * by
      const vx = 3 * u * u * (c1x - ax) + 6 * u * k * (c2x - c1x) + 3 * k * k * (bx - c2x),
        vy = 3 * u * u * (c1y - ay) + 6 * u * k * (c2y - c1y) + 3 * k * k * (by - c2y)
      const size = cell * k + 2.1 * ratio * u,
        length = size + envelope * Math.min(cell * 0.9, Math.hypot(vx, vy) * 0.045),
        width = Math.max(ratio * 0.75, size * (1 - 0.3 * envelope)),
        angle = Math.atan2(vy, vx) * (1 - waterEase(0.6, 0.98, k))
      pc.save()
      pc.translate(x, y)
      pc.rotate(angle)
      if (envelope > 0.08) {
        const sheen = pc.createLinearGradient(-length / 2, 0, length / 2, 0)
        sheen.addColorStop(0, '#8f81a7')
        sheen.addColorStop(0.55, '#c7c9d7')
        sheen.addColorStop(1, '#dcdbe8')
        pc.fillStyle = sheen
      } else pc.fillStyle = codeMetal(bx, by)
      const settle = waterEase(0.83, 1, k)
      pc.beginPath()
      pc.roundRect(
        -length / 2,
        -width / 2,
        length,
        width,
        ((1 - settle) * width) / 2 + settle * 0.35 * ratio
      )
      pc.fill()
      pc.restore()
    }
  }
  function scenePoint(x, y, z, type, w, h) {
    [x, y, z] = applyPose(
      [x, y, z],
      metalPose(storyState(), traveler ? pose.morph : style.preview)
    )
    const s = (h / 2.72) * sculptureScale()
    return { x: w / 2 + x * s, y: h / 2 - y * s }
  }
  function drawPixels(w, h, state, follow) {
    if (pixels.width !== w || pixels.height !== h) {
      pixels.width = w
      pixels.height = h
    }
    pc.clearRect(0, 0, w, h)
    if (root.dataset.webgl === 'fallback') return
    const staying = 1 - smooth(0, 0.5, follow)
    if (staying < 0.001) return
    if (state.code > 0.001) drawCodeFlow(w, h, state, staying)
    const ticketOpacity = smooth(0.6, 0.96, state.ticket) * staying
    if (ticketOpacity > 0.001) {
      const origin = scenePoint(0.32, 0.22, 0.018, 'ticket', w, h),
        u = scenePoint(0.76, 0.22, 0.018, 'ticket', w, h),
        v = scenePoint(0.32, -0.22, 0.018, 'ticket', w, h)
      pc.save()
      pc.setTransform(
        (u.x - origin.x) / qr.length,
        (u.y - origin.y) / qr.length,
        (v.x - origin.x) / qr.length,
        (v.y - origin.y) / qr.length,
        origin.x,
        origin.y
      )
      pc.globalAlpha = ticketOpacity * 0.92
      pc.fillStyle = '#f5f6fb'
      for (let y = 0; y < qr.length; y++)
        for (let x = 0; x < qr.length; x++) if (qr[y][x]) pc.fillRect(x, y, 1, 1)
      pc.restore()
    }
    const stageOpacity = smooth(0.65, 0.98, state.stage) * staying
    if (stageOpacity > 0.001) {
      pc.save()
      pc.globalAlpha = stageOpacity
      for (const sign of [-1, 1]) {
        const from = scenePoint(sign * 0.44, 0.4, 0.06, 'stage', w, h),
          aim = sign * (0.1 + 0.25 * Math.sin(time * 0.6)),
          left = scenePoint(aim - 0.22, -0.49, 0.1, 'stage', w, h),
          right = scenePoint(aim + 0.22, -0.49, 0.1, 'stage', w, h),
          g = pc.createLinearGradient(from.x, from.y, (left.x + right.x) / 2, left.y)
        g.addColorStop(0, '#8f81a74a')
        g.addColorStop(1, '#8f81a700')
        pc.fillStyle = g
        pc.beginPath()
        pc.moveTo(from.x, from.y)
        pc.lineTo(left.x, left.y)
        pc.lineTo(right.x, right.y)
        pc.closePath()
        pc.fill()
      }
      pc.restore()
    }
    pc.globalAlpha = 1
  }
  // A persistent closed mesh: its vertices travel between silhouettes without dissolving.
  let gl
  try {
    gl = canvas.getContext('webgl', { alpha: true, antialias: true, premultipliedAlpha: false })
  } catch {
    gl = null
  }
  const shaders = []
  let paletteTexture
  let program = null,
    uniforms
  const TAU = Math.PI * 2,
    PATH_STEPS = 192,
    PROFILE_STEPS = 12
  const vadd = (a, b) => a.map((v, i) => v + b[i]),
    vsub = (a, b) => a.map((v, i) => v - b[i]),
    vmul = (a, s) => a.map((v) => v * s),
    vlerp = (a, b, t) => a.map((v, i) => v + (b[i] - v) * t)
  const vlength = (a) => Math.hypot(...a),
    vunit = (a) => vmul(a, 1 / Math.max(vlength(a), 1e-8))
  const vcross = (a, b) => [
    a[1] * b[2] - a[2] * b[1],
    a[2] * b[0] - a[0] * b[2],
    a[0] * b[1] - a[1] * b[0],
  ]
  function resampleClosed(points, count) {
    const cumulative = [0]
    for (let i = 0; i < points.length; i++)
      cumulative.push(cumulative.at(-1) + vlength(vsub(points[(i + 1) % points.length], points[i])))
    const total = cumulative.at(-1),
      out = []
    let j = 0
    for (let i = 0; i < count; i++) {
      const d = (i / count) * total
      while (j + 1 < points.length && cumulative[j + 1] < d) j++
      out.push(
        vlerp(
          points[j],
          points[(j + 1) % points.length],
          (d - cumulative[j]) / (cumulative[j + 1] - cumulative[j])
        )
      )
    }
    return out
  }
  function roundedPolygon(points, radius = 0.035) {
    const out = []
    for (let i = 0; i < points.length; i++) {
      const a = points[(i + points.length - 1) % points.length],
        b = points[i],
        c = points[(i + 1) % points.length],
        before = vlerp(b, a, Math.min(0.2, radius / vlength(vsub(a, b)))),
        after = vlerp(b, c, Math.min(0.2, radius / vlength(vsub(c, b))))
      for (let k = 0; k < 7; k++) {
        const t = k / 6
        out.push(vlerp(vlerp(before, b, t), vlerp(b, after, t), t))
      }
    }
    return out
  }
  const ticketPath = resampleClosed(
    Array.from({ length: 768 }, (_, i) => {
      const a = (i / 768) * TAU,
        c = Math.cos(a),
        s = Math.sin(a)
      let x = 0.94 * Math.sign(c) * Math.pow(Math.abs(c), 0.34),
        y = 0.53 * Math.sign(s) * Math.pow(Math.abs(s), 0.34)
      x -= Math.sign(x) * 0.135 * Math.exp(-Math.pow(y / 0.115, 4))
      return [x, y, 0]
    }),
    PATH_STEPS
  )
  const stagePath = resampleClosed(
    roundedPolygon(
      [
        [0.84, 0, 0],
        [0.84, 0.52, 0],
        [0.72, 0.65, -0.12],
        [-0.72, 0.65, -0.12],
        [-0.84, 0.52, 0],
        [-0.84, -0.46, 0],
        [-1.01, -0.53, 0.13],
        [-1.01, -0.6, 0.13],
        [1.01, -0.6, 0.13],
        [1.01, -0.53, 0.13],
        [0.84, -0.46, 0],
      ],
      0.045
    ),
    PATH_STEPS
  )
  // Reference: joined thumbs above, palms turned inward, fingers together at the lower tip.
  const signalPath = resampleClosed(
    roundedPolygon(
      [
        [0.34, 0.16, 0],
        [0.35, 0.36, 0],
        [0.27, 0.44, 0],
        [0.11, 0.44, 0],
        [0, 0.49, 0],
        [-0.11, 0.44, 0],
        [-0.27, 0.44, 0],
        [-0.35, 0.36, 0],
        [-0.34, 0.16, 0],
        [-0.22, -0.06, 0],
        [0, -0.36, 0],
        [0.22, -0.06, 0],
      ],
      0.08
    ),
    PATH_STEPS
  )
  const signalOuter = [
    [0, 0.49, 0],
    [0, 0.57, 0],
    [-0.11, 0.59, 0],
    [-0.35, 0.6, 0],
    [-0.62, 0.65, 0],
    [-0.86, 0.7, 0],
    [-0.98, 0.37, 0],
    [-0.78, 0.2, 0],
    [-0.68, 0.07, 0],
    [-0.5, -0.17, 0],
    [-0.27, -0.42, 0],
    [-0.065, -0.64, 0],
    [0, -0.7, 0],
  ]
  function softenOpen(points) {
    const out = []
    for (let i = 0; i < points.length - 1; i++) {
      const a = points[Math.max(0, i - 1)],
        b = points[i],
        c = points[i + 1],
        d = points[Math.min(points.length - 1, i + 2)]
      for (let j = 0; j < 6; j++) {
        const t = j / 6
        out.push(
          b.map(
            (v, k) =>
              0.5 *
              (2 * v +
                (-a[k] + c[k]) * t +
                (2 * a[k] - 5 * v + 4 * c[k] - d[k]) * t * t +
                (-a[k] + 3 * v - 3 * c[k] + d[k]) * t * t * t)
          )
        )
      }
    }
    out.push(points.at(-1))
    return out
  }
  const signalSides = [-1, 1].map((sign) =>
    softenOpen(signalOuter.map((p) => [p[0] * sign, p[1], p[2]]))
  )
  function ribbonCenter(a) {
    const t = time * 0.82,
      r =
        0.79 + (0.09 * Math.sin(a * 2 + t * 0.6) + 0.024 * Math.sin(a * 3 - t * 0.75)) * style.life
    const y = (r * Math.sin(a)) / (0.98 + 0.07 * Math.sin(t * 0.85) * style.life),
      x = r * Math.cos(a) - 0.12 * Math.sin(y * 2.7 + t * 0.9) * style.life,
      z = (0.17 * Math.sin(a * 2 + t * 0.48) + 0.035 * Math.cos(a * 3 - t * 0.65)) * style.life
    return [x, y, z]
  }
  function liquidBlend(source, target, amount, a) {
    if (amount <= 0) return source
    if (amount >= 1) return target
    const wave = Math.pow(Math.sin(Math.PI * amount), 2),
      lag = 0.055 * Math.sin(a * 2 - time * 0.38) * wave,
      k = amount + lag,
      p = vlerp(source, target, k),
      swell = 0.043 * Math.sin(a * 2 - time * 0.62) * wave
    return [
      p[0] + swell * Math.cos(a),
      p[1] + swell * Math.sin(a),
      p[2] + 0.028 * wave * Math.sin(a * 3 - time * 0.55),
    ]
  }
  function rectPath(cx, cy, hw, hh, z = 0) {
    return resampleClosed(
      roundedPolygon(
        [
          [cx + hw, cy + hh, z],
          [cx - hw, cy + hh, z],
          [cx - hw, cy - hh, z],
          [cx + hw, cy - hh, z],
        ],
        0.025
      ),
      48
    )
  }
  function circlePath(cx, cy, r, z = 0) {
    return Array.from({ length: 32 }, (_, i) => [
      cx + r * Math.cos((i / 32) * TAU),
      cy + r * Math.sin((i / 32) * TAU),
      z,
    ])
  }
  function metalPose(state, follow) {
    const t = time * 0.82,
      ribbon = 1 - state.ticket - state.stage - state.signal,
      keep = 1 - follow
    return {
      roll:
        keep *
        ((-0.13 + 0.22 * Math.sin(t * 0.72) * style.life + mouse * 0.12) * ribbon +
          (0.05 + 0.05 * Math.sin(time * 0.42)) * state.ticket +
          (-0.025 + 0.035 * Math.sin(time * 0.4)) * state.stage +
          0.025 * Math.sin(time * 0.5) * state.signal),
      yaw:
        keep *
        ((0.27 + 0.36 * Math.sin(t * 0.34)) * ribbon +
          0.18 * Math.sin(time * 0.36) * state.ticket +
          (0.16 + 0.06 * Math.sin(time * 0.34)) * state.stage +
          0.08 * Math.sin(time * 0.45) * state.signal),
      pitch:
        keep *
        (0.12 * Math.sin(t * 0.48) * ribbon + (0.08 + 0.02 * Math.sin(time * 0.4)) * state.stage),
      x: keep * 0.05 * Math.sin(t * 0.45) * ribbon,
      y: keep * (0.07 * Math.sin(t * 0.72) * ribbon + 0.025 * Math.sin(time * 0.5) * (1 - ribbon)),
    }
  }
  function applyPose(point, pose, normal = false) {
    let [x, y, z] = point
    ;[y, z] = turn(y, z, -pose.pitch)
    ;[x, z] = turn(x, z, -pose.yaw)
    ;[x, y] = turn(x, y, -pose.roll)
    return [x + (normal ? 0 : pose.x), y + (normal ? 0 : pose.y), z]
  }
  const meshCache = new Map()
  let positionBuffer, normalBuffer, indexBuffer, positionAttr, normalAttr
  function renderTube(
    path,
    a,
    b,
    pose,
    { closed = true, twist = false, profile = PROFILE_STEPS } = {}
  ) {
    const n = closed ? path.length : path.length - 1,
      key = `${n}:${profile}:${closed}`
    let mesh = meshCache.get(key)
    if (!mesh) {
      const count = (n + 1) * profile,
        indices = []
      for (let i = 0; i < n; i++)
        for (let j = 0; j < profile; j++) {
          const a = i * profile + j,
            b = i * profile + ((j + 1) % profile),
            c = (i + 1) * profile + j,
            d = (i + 1) * profile + ((j + 1) % profile)
          indices.push(a, c, b, b, c, d)
        }
      mesh = {
        positions: new Float32Array(count * 3),
        normals: new Float32Array(count * 3),
        local: new Float32Array(count * 3),
        indices: new Uint16Array(indices),
      }
      meshCache.set(key, mesh)
    }
    const at = (i, j) => {
      let shift = 0
      if (closed) {
        if (i < 0) {
          i = n - 1
          shift = twist ? profile / 2 : 0
        }
        if (i > n) {
          i = 1
          shift = twist ? profile / 2 : 0
        }
      } else i = Math.max(0, Math.min(n, i))
      j = (j + shift + profile) % profile
      const k = (i * profile + j) * 3
      return [mesh.local[k], mesh.local[k + 1], mesh.local[k + 2]]
    }
    for (let i = 0; i <= n; i++) {
      const center = path[i % path.length],
        previous = path[closed ? (i - 1 + n) % n : Math.max(0, i - 1)],
        next = path[closed ? (i + 1) % n : Math.min(n, i + 1)],
        tangent = vunit(vsub(next, previous))
      let side = vunit(vcross(tangent, [0, 0, 1]))
      if (vlength(side) < 0.5) side = [1, 0, 0]
      const up = vunit(vcross(side, tangent)),
        angle = twist
          ? (i / n) * Math.PI * 3 +
            0.32 * Math.sin(time * 0.55) +
            0.18 * Math.sin((i / n) * TAU * 2 - time * 0.7)
          : 0,
        cs = Math.cos(angle),
        sn = Math.sin(angle)
      for (let j = 0; j < profile; j++) {
        const u = (j / profile) * TAU,
          x = a * Math.cos(u),
          y = b * Math.sin(u),
          point = vadd(center, vadd(vmul(side, x * cs - y * sn), vmul(up, x * sn + y * cs))),
          k = (i * profile + j) * 3
        mesh.local.set(point, k)
      }
    }
    for (let i = 0; i <= n; i++)
      for (let j = 0; j < profile; j++) {
        const k = (i * profile + j) * 3,
          point = at(i, j),
          normal = vunit(vcross(vsub(at(i + 1, j), at(i - 1, j)), vsub(at(i, j + 1), at(i, j - 1))))
        mesh.positions.set(applyPose(point, pose), k)
        mesh.normals.set(applyPose(normal, pose, true), k)
      }
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer)
    gl.bufferData(gl.ARRAY_BUFFER, mesh.positions, gl.DYNAMIC_DRAW)
    gl.vertexAttribPointer(positionAttr, 3, gl.FLOAT, false, 0, 0)
    gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer)
    gl.bufferData(gl.ARRAY_BUFFER, mesh.normals, gl.DYNAMIC_DRAW)
    gl.vertexAttribPointer(normalAttr, 3, gl.FLOAT, false, 0, 0)
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer)
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, mesh.indices, gl.DYNAMIC_DRAW)
    gl.drawElements(gl.TRIANGLES, mesh.indices.length, gl.UNSIGNED_SHORT, 0)
  }
  if (gl) {
    const vertex = `attribute vec3 position;attribute vec3 normal;uniform vec2 res;uniform float sculptureSize;varying vec3 vNormal;varying vec3 vPosition;void main(){vNormal=normal;vPosition=position;float zoom=2.*sculptureSize/2.72;gl_Position=vec4(position.x*zoom*res.y/res.x,position.y*zoom,-position.z*.25,1.);}`
    const fragment = `precision highp float;uniform sampler2D palette;uniform float age;uniform float follow;varying vec3 vNormal;varying vec3 vPosition;
 float softbox(vec3 ray,vec3 direction,vec2 size,float feather){vec3 axis=normalize(direction),side=normalize(cross(vec3(0.,1.,0.),axis)),up=cross(axis,side);float facing=dot(ray,axis);vec2 q=vec2(dot(ray,side),dot(ray,up))/max(facing,.001);vec2 edge=1.-smoothstep(size-vec2(feather),size+vec2(feather),abs(q));float falloff=.45+.55/(1.+.35*dot(q,q));return edge.x*edge.y*smoothstep(0.,.25,facing)*falloff;}
 vec3 env(vec3 ray){vec3 graphite=pow(texture2D(palette,vec2(.18,.5)).rgb,vec3(2.2)),silver=pow(texture2D(palette,vec2(.33,.5)).rgb,vec3(2.2)),purple=pow(texture2D(palette,vec2(.35,.5)).rgb,vec3(2.2));float sky=smoothstep(-.75,.85,ray.y);vec3 room=mix(graphite*.8,silver*.17,sky);room+=silver*softbox(ray,vec3(-1.1,.55,1.25),vec2(.33,4.),.24)*.8;room+=silver*softbox(ray,vec3(.85,.35,-.7),vec2(.18,3.),.11)*.9;room+=silver*softbox(ray,vec3(-.15,1.,-.3),vec2(1.5,.36),.4)*.26;room+=purple*softbox(ray,vec3(1.1,-.2,1.),vec2(.35,2.),.25)*.26;room+=purple*softbox(ray,vec3(-.65,-.8,-.5),vec2(.8,.4),.2)*.24;return room*(1.-.88*softbox(ray,vec3(0.,-.3,1.),vec2(.18,1.8),.14));}
 vec3 displayMetal(vec3 c){return pow(clamp((c*(2.51*c+.03))/(c*(2.43*c+.59)+.14),0.,1.),vec3(1./2.2));}
 void main(){vec3 n=normalize(vNormal);if(!gl_FrontFacing)n=-n;float f=pow(1.-max(n.z,0.),5.);vec3 metal=displayMetal(env(reflect(vec3(0.,0.,-1.),n))*mix(vec3(.82,.83,.87),vec3(1.),f));float sweep=fract(atan(vPosition.y,vPosition.x)/6.2831853+age*.09);vec3 orbital=texture2D(palette,vec2(sweep,.5)).rgb;gl_FragColor=vec4(mix(metal,orbital,smoothstep(.7,1.,follow)),1.);}`
    const compile = (type, source) => {
      const shader = gl.createShader(type)
      shaders.push(shader)
      gl.shaderSource(shader, source)
      gl.compileShader(shader)
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS))
        throw Error(gl.getShaderInfoLog(shader))
      return shader
    }
    try {
      program = gl.createProgram()
      gl.attachShader(program, compile(gl.VERTEX_SHADER, vertex))
      gl.attachShader(program, compile(gl.FRAGMENT_SHADER, fragment))
      gl.linkProgram(program)
      if (!gl.getProgramParameter(program, gl.LINK_STATUS))
        throw Error(gl.getProgramInfoLog(program))
      gl.useProgram(program)
      uniforms = Object.fromEntries(
        ['res', 'sculptureSize', 'age', 'follow', 'palette'].map((k) => [
          k,
          gl.getUniformLocation(program, k),
        ])
      )
      positionBuffer = gl.createBuffer()
      normalBuffer = gl.createBuffer()
      indexBuffer = gl.createBuffer()
      positionAttr = gl.getAttribLocation(program, 'position')
      normalAttr = gl.getAttribLocation(program, 'normal')
      gl.enableVertexAttribArray(positionAttr)
      gl.enableVertexAttribArray(normalAttr)
      const paletteCanvas = document.createElement('canvas')
      paletteCanvas.width = 512
      paletteCanvas.height = 1
      const ctx = paletteCanvas.getContext('2d'),
        gradient = ctx.createLinearGradient(0, 0, 512, 0),
        stops = [
          ...getComputedStyle(root)
            .getPropertyValue('--fomo-silver-purple-ring')
            .matchAll(/(#[\da-f]{6})\s+([\d.]+)%/gi),
        ]
      if (stops.length < 2) throw Error('FOMO loader palette unavailable')
      stops.forEach((s) => gradient.addColorStop(Number(s[2]) / 100, s[1]))
      ctx.fillStyle = gradient
      ctx.fillRect(0, 0, 512, 1)
      const tex = gl.createTexture()
      paletteTexture = tex
      gl.activeTexture(gl.TEXTURE0)
      gl.bindTexture(gl.TEXTURE_2D, tex)
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR)
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR)
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, paletteCanvas)
      gl.uniform1i(uniforms.palette, 0)
      gl.enable(gl.DEPTH_TEST)
      gl.depthFunc(gl.LEQUAL)
      root.dataset.webgl = 'true'
    } catch (error) {
      if (program) gl.deleteProgram(program)
      program = null
      root.dataset.webgl = 'fallback'
      root.dataset.renderError = error.message
    }
  }
  function renderSculpture(state, follow, w, h) {
    gl.viewport(0, 0, w, h)
    gl.useProgram(program)
    gl.uniform2f(uniforms.res, w, h)
    gl.uniform1f(uniforms.age, time)
    gl.uniform1f(uniforms.sculptureSize, sculptureScale())
    gl.uniform1f(uniforms.follow, follow)
    gl.clearColor(0, 0, 0, 0)
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)
    const path = [],
      pose = metalPose(state, follow),
      scene = Math.max(state.ticket, state.stage, state.signal)
    for (let i = 0; i < PATH_STEPS; i++) {
      const a = (i / PATH_STEPS) * TAU
      let point = liquidBlend(ribbonCenter(a), ticketPath[i], state.ticket, a)
      point = liquidBlend(point, stagePath[i], state.stage, a)
      point = liquidBlend(point, signalPath[i], state.signal, a)
      const circle = [
        (0.67 + 0.005 * Math.sin(a * 3 + time * 0.3)) * Math.cos(a),
        (0.67 + 0.005 * Math.sin(a * 3 + time * 0.3)) * Math.sin(a),
        0,
      ]
      path.push(vlerp(point, circle, follow))
    }
    const a = (0.08 + (0.018 - 0.08) * scene) * (1 - follow) + 0.034 * follow,
      b = (0.016 + (0.018 - 0.016) * scene) * (1 - follow) + 0.034 * follow
    const qrTaper = 1 - 0.84 * smooth(0.1, 0.9, state.code) * (1 - smooth(0, 0.2, follow))
    renderTube(path, a * qrTaper, b * qrTaper, pose, { twist: true })
    const visible = 1 - smooth(0, 0.45, follow),
      ticket = smooth(0.45, 0.98, state.ticket) * visible,
      stage = smooth(0.5, 0.98, state.stage) * visible,
      signal = smooth(0.45, 0.98, state.signal) * visible
    const line = (points, r) => renderTube(points, r, r, pose, { closed: false, profile: 8 })
    if (ticket > 0.015) {
      for (let i = 0; i < 8; i++) {
        const y = -0.385 + i * 0.11
        line(
          [
            [0.19, y - 0.026, 0],
            [0.19, y + 0.026, 0],
          ],
          0.008 * ticket
        )
      }
      line(
        [
          [-0.7, 0.18, 0],
          [-0.18, 0.18, 0],
        ],
        0.01 * ticket
      )
      line(
        [
          [-0.7, -0.01, 0],
          [-0.32, -0.01, 0],
        ],
        0.008 * ticket
      )
      line(
        [
          [-0.7, -0.18, 0],
          [-0.45, -0.18, 0],
        ],
        0.008 * ticket
      )
    }
    if (stage > 0.015) {
      line(
        [
          [-0.84, 0.52, 0],
          [0.84, 0.52, 0],
        ],
        0.015 * stage
      )
      line(
        [
          [-0.85, -0.46, -0.25],
          [0.85, -0.46, -0.25],
        ],
        0.013 * stage
      )
      line(
        [
          [-1.01, -0.53, 0.13],
          [-0.85, -0.46, -0.25],
        ],
        0.013 * stage
      )
      line(
        [
          [1.01, -0.53, 0.13],
          [0.85, -0.46, -0.25],
        ],
        0.013 * stage
      )
      renderTube(rectPath(0, -0.025, 0.43, 0.265, -0.17), 0.012 * stage, 0.012 * stage, pose, {
        profile: 8,
      })
      for (const x of [-0.63, 0.63]) {
        renderTube(rectPath(x, -0.19, 0.115, 0.26, 0.04), 0.012 * stage, 0.012 * stage, pose, {
          profile: 8,
        })
        for (const y of [-0.305, -0.075])
          renderTube(circlePath(x, y, 0.071, 0.04), 0.007 * stage, 0.007 * stage, pose, {
            profile: 8,
          })
      }
      for (const x of [-0.44, 0, 0.44])
        renderTube(circlePath(x, 0.43, 0.028, 0.035), 0.009 * stage, 0.009 * stage, pose, {
          profile: 8,
        })
    }
    if (signal > 0.015) {
      for (const side of signalSides) line(side, 0.014 * signal)
      for (const sign of [-1, 1]) {
        const mirror = (p) => p.map(([x, y, z]) => [x * sign, y, z])
        for (const crease of [
          [
            [-0.85, 0.61, 0],
            [-0.83, 0.45, 0],
            [-0.88, 0.35, 0],
          ],
          [
            [-0.71, 0.4, 0],
            [-0.5, 0.42, 0],
            [-0.38, 0.4, 0],
          ],
          [
            [-0.51, 0.17, 0],
            [-0.35, -0.1, 0],
            [-0.1, -0.4, 0],
            [0, -0.48, 0],
          ],
          [
            [-0.6, 0.08, 0],
            [-0.43, -0.17, 0],
            [-0.17, -0.43, 0],
            [0, -0.6, 0],
          ],
          [
            [-0.27, 0.54, 0],
            [-0.13, 0.54, 0],
            [-0.08, 0.5, 0],
          ],
        ])
          line(softenOpen(mirror(crease)), 0.007 * signal)
      }
    }
  }

  if (!program) {
    root.dataset.webgl = 'fallback'
    playing = false
  }
  const anchor = $('.fq-art'),
    sculpture = $('.fq-sculpture')
  let traveler = null,
    layer = null,
    railSection = null,
    scrollImpulse = 0,
    previousScroll = scrollY
  const home = root.closest('.fomo-home'),
    pose = { x: 0, y: 0, scale: 1, morph: 0 }
  function followFrame(dt, snap = false) {
    if (!traveler) return
    const a = anchor.getBoundingClientRect(),
      r = root.getBoundingClientRect()
    const progress =
      smooth(0, r.height * 0.95, scrollY - Math.max(0, r.top + scrollY - 130)) *
      smooth(1.25, 2.05, time)
    const motionControls = $('.fq-controls')
    motionControls.style.opacity = String(1 - smooth(0, 0.22, progress))
    motionControls.style.visibility = progress >= 0.22 ? 'hidden' : 'visible'
    const small = innerWidth < 651,
      gutter = small ? 32 : 64,
      targetHeight = small ? 44 : 56
    const form = smooth(0, small ? 0.45 : 0.6, progress),
      s = 1 + (targetHeight / a.height - 1) * form,
      move = smooth(0, small ? 0.42 : 0.55, progress)
    railSection =
      Array.from(home?.querySelectorAll('.home-event-rail') || []).find(
        (section) => section.getBoundingClientRect().height > 0
      ) || null
    const railRight =
        railSection?.getBoundingClientRect().right ?? root.getBoundingClientRect().right,
      centerX = railRight - gutter / 2
    const targetX = a.left * (1 - move) + (centerX - (a.width * s) / 2) * move
    const targetY =
      a.top * (1 - move) + (innerHeight * 0.62 - targetHeight / 2 + scrollImpulse * 0.012) * move
    const easing = snap ? 1 : 1 - Math.exp(-dt * 6.5)
    pose.x += (targetX - pose.x) * easing
    pose.y += (targetY - pose.y) * easing
    pose.scale += (s - pose.scale) * easing
    pose.morph += (form - pose.morph) * easing
    // Complete the move into the reserved margin before descending alongside posters.
    const radius = a.height * pose.scale * (0.52 - 0.21 * smooth(0.8, 0.99, pose.morph))
    const clearOfCards =
      pose.x + (a.width * pose.scale) / 2 - radius >= railRight - gutter + (small ? 2 : 4)
    const firstCardTop = railSection?.querySelector('.wow-card')?.getBoundingClientRect().top
    if (!clearOfCards && Number.isFinite(firstCardTop))
      pose.y = Math.min(pose.y, firstCardTop - a.height * pose.scale - 16)
    scrollImpulse *= Math.exp(-dt * 4)
    traveler.style.width = a.width + 'px'
    traveler.style.height = a.height + 'px'
    traveler.style.transform = `translate3d(${pose.x.toFixed(2)}px,${pose.y.toFixed(
      2
    )}px,0) scale(${pose.scale.toFixed(4)})`
    root.dataset.followProgress = pose.morph.toFixed(3)
  }

  function setupTraveler() {
    if (traveler || !program || reduced.matches || !home?.querySelector('#agenda-activa')) return
    layer = document.createElement('div')
    layer.id = 'fomo-orbit-layer'
    layer.setAttribute('aria-hidden', 'true')
    traveler = document.createElement('div')
    traveler.id = 'fomo-orbit-traveler'
    layer.append(traveler)
    document.body.append(layer)
    traveler.append(sculpture)
    root.dataset.follow = 'morph-to-orbit'
    followFrame(0, true)
    draw()
    wake()
  }
  function removeTraveler() {
    if (!traveler) return
    anchor.append(sculpture)
    layer.remove()
    railSection = null
    layer = null
    traveler = null
    pose.morph = 0
    root.dataset.follow = 'false'
    $('.fq-controls').style.opacity = '1'
    $('.fq-controls').style.visibility = 'visible'
  }
  function draw() {
    if (disposed) return
    root.dataset.layout =
      root.clientWidth < 600 ? 'mobile' : root.clientWidth < 980 ? 'compact' : 'wide'
    const state = storyState(),
      follow = traveler ? pose.morph : style.preview
    root.dataset.phase = state.code > 0.98 ? 'qr' : state.code > 0.02 ? 'morph' : 'liquid'
    root.dataset.storyForm = state.form
    root.dataset.cycleTime = state.cycle.toFixed(2)
    root.dataset.animationTime = time.toFixed(2)
    root.dataset.companion = 'orbit'
    const r = anchor.getBoundingClientRect()
    drawPixels(
      Math.max(1, Math.round(r.width * 2)),
      Math.max(1, Math.round(r.height * 2)),
      state,
      follow
    )
    const opacity = Math.max(1 - smooth(0.74, 0.995, state.code), smooth(0, 0.5, follow))
    canvas.style.opacity = String(opacity)
    if (!program || opacity < 0.001 || (!visible && !traveler)) return
    const scale = traveler && pose.morph > 0.985 ? Math.max(0.25, 2 * pose.scale) : 2,
      w = Math.max(1, Math.round(r.width * scale)),
      h = Math.max(1, Math.round(r.height * scale))
    if (canvas.width !== w || canvas.height !== h) {
      canvas.width = w
      canvas.height = h
    }
    renderSculpture(state, follow, w, h)
  }
  function frame(now) {
    raf = 0
    if (disposed || !playing || (!visible && !traveler) || document.hidden) return
    if (!last) last = now
    const elapsed = Math.min((now - last) / 1000, 1),
      dt = Math.min(elapsed, 0.25)
    last = now
    time += elapsed * style.speed
    mouse += (mouseTarget - mouse) * Math.min(1, dt * 4)
    followFrame(dt)
    if (now - previousDraw > 15) {
      draw()
      previousDraw = now
    }
    raf = requestAnimationFrame(frame)
  }
  function wake() {
    if (!disposed && playing && (visible || traveler) && !document.hidden && !raf) {
      last = 0
      raf = requestAnimationFrame(frame)
    }
  }
  function controls() {
    root.dataset.playing = String(playing)
    $('[data-pause]').setAttribute('aria-pressed', String(!playing))
    $('[data-pause-text]').textContent = playing ? 'Pausar' : 'Reanudar'
    $('[data-pause-symbol]').textContent = playing ? 'Ⅱ' : '▷'
  }

  const disposers = []
  function listen(target, event, handler, options) {
    target.addEventListener(event, handler, options)
    disposers.push(() => target.removeEventListener(event, handler, options))
  }
  function stopFrame() {
    if (raf) cancelAnimationFrame(raf)
    raf = 0
    last = 0
  }
  function syncControls() {
    controls()
    $('[data-pause]').disabled = reduced.matches || !program
    $('[data-replay]').disabled = reduced.matches || !program
  }
  listen($('[data-pause]'), 'click', () => {
    playing = !playing
    syncControls()
    if (!playing) stopFrame()
    else wake()
    $('[data-status]').textContent = playing ? 'Movimiento reanudado.' : 'Movimiento en pausa.'
  })
  listen($('[data-replay]'), 'click', () => {
    time = 0
    mouse = 0
    mouseTarget = 0
    last = 0
    followFrame(0, true)
    draw()
    wake()
    $('[data-status]').textContent = 'Secuencia reiniciada desde el QR.'
  })
  listen(root, 'pointermove', (e) => {
    if (reduced.matches) return
    const r = root.getBoundingClientRect()
    mouseTarget = (e.clientX - r.left) / r.width - 0.5
  })
  listen(root, 'pointerleave', () => (mouseTarget = 0))
  const resizeObserver = new ResizeObserver(() => {
    if (disposed) return
    draw()
    followFrame(0, true)
  })
  resizeObserver.observe(anchor)
  const intersectionObserver = new IntersectionObserver(
    (entries) => {
      visible = entries[0].isIntersecting
      if (visible || traveler) wake()
      else stopFrame()
    },
    { threshold: 0.05 }
  )
  intersectionObserver.observe(root)
  listen(document, 'visibilitychange', () => {
    if (document.hidden) stopFrame()
    else wake()
  })
  listen(reduced, 'change', () => {
    stopFrame()
    time = 0
    playing = !reduced.matches && !!program
    if (reduced.matches) removeTraveler()
    else setupTraveler()
    syncControls()
    draw()
    wake()
  })
  listen(
    window,
    'scroll',
    () => {
      scrollImpulse = Math.max(-900, Math.min(900, scrollImpulse + (scrollY - previousScroll) * 4))
      previousScroll = scrollY
      if (!playing) {
        followFrame(0, true)
        draw()
      } else wake()
    },
    { passive: true }
  )
  listen(window, 'resize', () => {
    draw()
    followFrame(0, true)
  })
  listen(canvas, 'webglcontextlost', (event) => {
    event.preventDefault()
    stopFrame()
    playing = false
    program = null
    root.dataset.webgl = 'fallback'
    removeTraveler()
    pc.clearRect(0, 0, pixels.width, pixels.height)
    canvas.style.opacity = '0'
    syncControls()
  })
  syncControls()
  draw()
  setupTraveler()
  wake()
  return function dispose() {
    if (disposed) return
    disposed = true
    stopFrame()
    resizeObserver.disconnect()
    intersectionObserver.disconnect()
    disposers.forEach((fn) => fn())
    removeTraveler()
    if (gl) {
      [positionBuffer, normalBuffer, indexBuffer]
        .filter(Boolean)
        .forEach((buffer) => gl.deleteBuffer(buffer))
      shaders.forEach((shader) => gl.deleteShader(shader))
      if (paletteTexture) gl.deleteTexture(paletteTexture)
      if (program) gl.deleteProgram(program)
      gl.getExtension('WEBGL_lose_context')?.loseContext()
    }
    meshCache.clear()
  }
}
